import { FC } from 'react';
import { Helmet } from 'react-helmet-async';

import Config from 'Config';
import { ProductMeta } from 'types/seo-meta';
import { Product } from 'types/product';
import { PRODUCTS_META } from 'constants/seo-meta';
import { detectProduct } from 'helpers/product';
import Location from 'services/Location';

export const SEO: FC = () => {
  const isOnLoginPage = Location.isInLogin();
  const isOnSignupPage = Location.isInSignup();
  const productMeta: ProductMeta =
    PRODUCTS_META[detectProduct()] ?? PRODUCTS_META[Product.Undefined];

  if (isOnLoginPage) {
    return (
      <Helmet defer={false}>
        <title>{productMeta.loginTitle}</title>
        <meta property="og:title" content={productMeta.loginTitle} />
        <meta name="description" content={productMeta.loginDescription} />
        <meta property="og:description" content={productMeta.loginDescription} />

        <link
          rel="canonical"
          href={`${Config.accounts_api_url}${window.location.pathname}${window.location.pathname !== '/' ? '/' : ''}`}
        />
      </Helmet>
    );
  }

  if (isOnSignupPage) {
    return (
      <Helmet defer={false}>
        <title>{productMeta.signupTitle}</title>
        <meta property="og:title" content={productMeta.signupTitle} />
        <meta name="description" content={productMeta.signupDescription} />
        <meta property="og:description" content={productMeta.signupDescription} />

        <link
          rel="canonical"
          href={`${Config.accounts_api_url}${window.location.pathname}${window.location.pathname !== '/' ? '/' : ''}`}
        />
      </Helmet>
    );
  }

  return (
    <Helmet defer={false}>
      <title>{productMeta.defaultTitle}</title>
      <meta property="og:title" content={productMeta.defaultTitle} />
      <meta name="description" content={productMeta.defaultDescription} />
      <meta property="og:description" content={productMeta.defaultDescription} />

      <link
        rel="canonical"
        href={`${Config.accounts_api_url}${window.location.pathname}${window.location.pathname !== '/' ? '/' : ''}`}
      />
    </Helmet>
  );
};
